import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideoOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVideoOff"><Path d="M14 19.5H2.5V4.75M6.5 4.5H15.5V16.5M1.5 3L16 21.5M21.5 7L15.5 10V14L21.5 17V7Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVideoOff;
